import React from 'react';
import { ClipboardList, BarChart3, Languages, Users } from 'lucide-react';
import { useLang, tx } from '../../i18n/LanguageContext';
import MultiCategorySelect from '../MultiCategorySelect';
import ColorPicker from '../ColorPicker';
import { EditorCard, Field, inputCls } from './ui';

export const LEVELS = { beginner: ['مبتدئ', 'Beginner'], intermediate: ['متوسط', 'Intermediate'], advanced: ['متقدم', 'Advanced'] };
export const levelKeyOf = (levelAr = '', levelEn = '') => Object.keys(LEVELS).find(k => levelAr.includes(LEVELS[k][0]) || levelEn.toLowerCase().includes(k)) || '';

const IconInput = ({ Icon, children }) => (
  <div className="relative">
    <Icon className="absolute top-1/2 -translate-y-1/2 start-3.5 w-4 h-4 text-slate-400 pointer-events-none" />
    {children}
  </div>
);

export const ExtraInfoCard = ({ form, set }) => {
  const { lang } = useLang();
  const L = (ar, en) => tx(lang, ar, en);
  const level = levelKeyOf(form.levelAr, form.levelEn);
  return (
    <EditorCard testId="course-extra-card" Icon={ClipboardList} title={L('معلومات إضافية', 'Additional information')} desc={L('معلومات تساعد في تنظيم وعرض الكورس', 'Details that help organize and display the course')}>
      <div className="grid sm:grid-cols-2 gap-4">
        <Field label={L('عدد الطلاب', 'Students count')}>
          <IconInput Icon={Users}>
            <input data-testid="course-students" type="number" min={0} className={`${inputCls} ps-10`} placeholder={L('مثال: 1200', 'e.g. 1200')} value={form.students || ''} onChange={e => set('students', parseInt(e.target.value, 10) || 0)} />
          </IconInput>
        </Field>
        <Field label={L('المستوى', 'Level')}>
          <IconInput Icon={BarChart3}>
            <select data-testid="course-level" className={`${inputCls} ps-10`} value={level}
              onChange={e => { const v = LEVELS[e.target.value] || ['', '']; set('levelAr', v[0]); set('levelEn', v[1]); }}>
              <option value="">{L('اختر المستوى', 'Select level')}</option>
              {Object.entries(LEVELS).map(([k, [ar, en]]) => <option key={k} value={k}>{lang === 'ar' ? ar : en}</option>)}
            </select>
          </IconInput>
        </Field>
        <Field label={L('التصنيفات', 'Categories')}>
          <MultiCategorySelect value={form.categories} onChange={arr => set('categories', arr)} dataTestId="course-categories" />
        </Field>
        <Field label={L('لغة الكورس الأساسية', 'Main course language')}>
          <IconInput Icon={Languages}>
            <select data-testid="course-language" className={`${inputCls} ps-10`} value={form.language} onChange={e => set('language', e.target.value)}>
              <option value="ar">{L('العربية', 'Arabic')}</option>
              <option value="en">{L('الإنجليزية', 'English')}</option>
            </select>
          </IconInput>
        </Field>
        <Field label={L('العلامة التجارية بالعربية', 'Brand (Arabic)')}>
          <input data-testid="course-brand-ar" className={inputCls} placeholder={L('مثال: SIEMENS', 'e.g. SIEMENS')} value={form.brandAr} onChange={e => set('brandAr', e.target.value)} />
        </Field>
        <Field label={L('العلامة التجارية بالإنجليزية', 'Brand (English)')}>
          <input data-testid="course-brand-en" dir="ltr" className={inputCls} placeholder="e.g. SIEMENS" value={form.brandEn} onChange={e => set('brandEn', e.target.value)} />
        </Field>
        <div className="sm:col-span-2">
          <Field label={L('لون البطاقة', 'Card color')}>
            <ColorPicker value={form.color} onChange={c => set('color', c)} testId="course-color" />
          </Field>
        </div>
      </div>
    </EditorCard>
  );
};
